var $ = jQuery;
$(document).ready(function ($) {
    // notification-bar
    if ($('.notification-bar').length > 0) {
        $('#closeNotificationBar').on('click', function () {
            $('.notification-bar').fadeOut(300, function () {
                $(this).remove();
                $('html').removeClass('has-notification-bar');
            });
        });
    }

    // Navigation responsive
    $('#transitcare_menu_trigger').on('click', function(){
        $navigationWrapper = $('.navigation-wrapper');

        $navigationWrapper.toggleClass('active');
        $('body').toggleClass('overflow-hidden')

        $notificationBar = $('.notification-bar');
        if( $notificationBar.length && $navigationWrapper.hasClass('active') ) {
            let notificationBarHeight = $notificationBar.outerHeight();
            $menuWrapper = $navigationWrapper.find('.menu-wrapper');
            $menuWrapper.css('top', (notificationBarHeight + 65) + 'px');
            $menuWrapper.css('height', 'calc(100vh - ' + (notificationBarHeight + 65) + 'px)');
        }  else {
            $menuWrapper.css('top', 65 + 'px');
            $menuWrapper.css('height', 'calc(100vh - ' + 65 + 'px)');
        }
    });


    // Window resize
    $header = $('header');
    $mainContent = $('#main');


    function adjustLayout() {
        $header = $('header');
        $mainContent = $('#main');

        if( $(window).width() > 1199 ) {
            $navigationWrapper = $('.navigation-wrapper');
            $notificationBar = $('.notification-bar');
            $menuWrapper = $navigationWrapper.find('.menu-wrapper');
            $menuWrapper.css('top', '0px');
            $menuWrapper.css('height', 'auto');

            $('body').removeClass('overflow-hidden');   
            $navigationWrapper.removeClass('active');
        }

        if( $header.length ) {
            $headerHeight = $header.outerHeight();
            // $mainContent.css('margin-top', $headerHeight + 'px');
        }
    }
    

    // Debounce utility
    function debounce(fn, delay) {
        let timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(fn, delay);
        };
    }

    adjustLayout();
    $(window).on('resize', debounce(adjustLayout, 200));

    $('.primary-navigation li.menu-item-has-children').on('click', function (event) {
        if ($(event.target).is('a, ul')) {
            return;
        }

        $(this).toggleClass('show_sub_menu');
    });

});

$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});

/**
 * FAQ Block Toggle All Functionality
 * Handles clicking the toggle-faqs link to expand/collapse all FAQ items within the same block
 */
document.addEventListener('DOMContentLoaded', function() {
    const toggleLinks = document.querySelectorAll('.blk-faq #toggle-faqs');

    toggleLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            const faqBlock = this.closest('.blk-faq');
            const checkboxes = faqBlock.querySelectorAll('input[type="checkbox"]');

            const allChecked = checkboxes.length > 0 &&
                Array.from(checkboxes).every(function(checkbox) {
                    return checkbox.checked;
                });

            checkboxes.forEach(function(checkbox) {
                checkbox.checked = !allChecked;
            });

            this.textContent = allChecked ? 'Expand all' : 'Collapse all';
        });
    });
});